import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Layout from 'components/Anyfit/common/Layout';
import styled from 'styled-components';
import { useAlert } from 'contexts/AlertContext';
import { fontSize, palette } from 'pages/AnyfitMall/theme';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from './config';
import {
  validateToken,
  parseTokenFromUrl,
  getTokenFromStorage,
} from 'pages/AnyfitMall/common';
import { getBranding } from 'utils/branding';
import OrderCancelButton from 'components/Anyfit/OrderCancelButton';
import AnyfitBackButton from 'components/Anyfit/AnyfitBackButton';
import ShippingNoticePopup from 'components/Anyfit/ShippingNoticePopup';
import { useSearchParams } from 'react-router-dom';
import { startTransition } from 'react';
import { giftApi } from 'pages/AnyfitGift/giftApi';
import { AgreementRequiredModal } from 'pages/AnyfitMall/components/AgreementRequiredModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  /* margin-top: 20px; */
  height: 100%;

  // min-width: 360px;
  min-height: 120vh;
  width: 100%;
`;

const NotContent = styled.div`
  font-size: 1.25rem;
  font-weight: bold;
  color: ${palette.Gray400};
  margin-top: 3rem;
`;

const Top = styled.div`
  display: flex;
  width: 85%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  color: #141414;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  font-family: 'Noto Sans KR', sans-serif;
  margin-top: 60px;
`;

// Styled Components
const OrderListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 30px;
  width: 90%;
`;

const OrderCard = styled.div`\
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 0 auto;
`;

const OrderCardUpper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.8rem;
`;

const OrderCardLower = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 0.6rem;
  gap: 0.8rem;
`;

const OrderImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 0.6rem;
`;

const OrderStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
`;

// background-color: ${(props) =>
//   props.status === '배송중' ? '#4caf50' : '#f44336'};

const statusColors = {
  DEFAULT: palette.AnyBlue,
  CANCEL: palette.Gray200,
};

const StatusBadge = styled.div`
  font-size: ${fontSize.big};
  color: white;
  // font-weight: bold;
  font-family: 'Noto Sans KR', sans-serif;
  background-color: ${({ status }) =>
    statusColors[status] || statusColors.DEFAULT};
  border-radius: 16px;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  min-width: 88px;
  white-space: nowrap; // "선물 완료"가 좁은 내부 폭에 강제 줄바꿈되던 이슈 방지

  display: inline-flex; // 컨텐츠 기반 가변 폭 + 정렬 유지
  justify-content: center;
  align-items: center;
  align-self: flex-start; // 부모 flex의 stretch로 세로 늘어나는 것 차단
`;

const OrderDate = styled.div`
  font-size: 0.875rem;
  color: #666;
`;

const OrderDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.2rem;
  font-size: 0.8rem;
  font-weight: bold;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

const OrderName = styled.div``;

const OrderPrice = styled.div`
  color: #333;
`;

const ShippingAddress = styled.div`
  color: #333;
  word-break: break-all;
  line-height: 1.4;
  max-width: 100%;
  overflow-wrap: break-word;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  justify-content: flex-end;
`;

const ShippingInquiryButton = styled.button`
  padding: 0.4rem 0.8rem;
  background-color: white;
  color: ${palette.Gray600};
  border: 1px solid ${palette.Gray300};
  border-radius: 4px;
  font-size: 0.75rem;
  height: auto;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${palette.Gray50};
    border-color: ${palette.Gray400};
  }
`;

const Guide = styled.div`
  padding-left: 10px;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: ${palette.Gray600};
  background-color: ${palette.Gray100};
  padding: 1rem;
  border-radius: 12px;
`;

const TabRow = styled.div`
  display: flex;
  width: 90%;
  margin: 0 auto 16px;
  border-bottom: 1px solid ${palette.Gray200};
`;

const TabBtn = styled.button`
  flex: 1;
  padding: 14px 0;
  background: none;
  border: none;
  border-bottom: 2px solid
    ${({ $active }) => ($active ? palette.AnyBlue : 'transparent')};
  color: ${({ $active }) => ($active ? palette.Gray900 : palette.Gray500)};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  font-size: 14px;
  cursor: pointer;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const Count = styled.span`
  font-size: 11px;
  background: ${palette.Gray100};
  color: ${palette.Gray600};
  border-radius: 10px;
  padding: 2px 8px;
`;

const AnyfitOrderList = () => {
  const { showAlert } = useAlert();
  const branding = getBranding();
  // 배송 공지 팝업 상태 추가
  const [showShippingNotice, setShowShippingNotice] = useState(false);
  const [agreementRequired, setAgreementRequired] = useState(false);
  const [agreementToken, setAgreementToken] = useState(null);

  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'gift' ? 'gift' : 'purchase';
  const [activeTab, setActiveTab] = useState(initialTab);
  const [giftOrders, setGiftOrders] = useState([]);
  const [giftLoaded, setGiftLoaded] = useState(false);

  const fetchOrders = async (token) => {
    const response = await fetch(`${API_BASE_URL}/api/getMyOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ token: token }),
    });

    if (response.ok) {
      const data = await response.json();
      setOrderList(data.orders);
    } else {
      console.error('Failed to fetch products:', response.statusText);
      showAlert('토큰이 유효하지 않습니다.');
      navigate('/anyfit/error');
    }
  };

  const completeOrder = async (impUid, merchantUid) => {
    try {
      const storedToken = getTokenFromStorage();
      if (!storedToken) {
        showAlert(
          `토큰이 유효하지 않습니다. ${branding.name}에서 재접속해주세요`,
        );
        navigate('/anyfit/error');
        return;
      }

      const completeOrderResponse = await fetch(
        `${API_BASE_URL}/api/completeOrderPayUser`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify({
            orderId: merchantUid,
            impUid: impUid,
          }),
        },
      );

      showAlert('주문이 완료되었습니다.');

      if (completeOrderResponse.ok) {
        fetchOrders(storedToken);
        setToken(storedToken);
        return;
      } else {
        showAlert(
          `토큰이 유효하지 않습니다. ${branding.name}에서 재접속해주세요`,
        );
        navigate('/anyfit/error');
      }

      // 주문 완료 후 페이지 새로고침
      // window.location.reload();
    } catch (error) {
      showAlert('주문 완료에 실패했습니다.');
      throw new Error(error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      const urlToken = parseTokenFromUrl();
      const stored = getTokenFromStorage();
      const useToken = urlToken || stored;

      if (!useToken) {
        showAlert('토큰이 유효하지 않습니다.');
        navigate('/anyfit/error');
        return;
      }

      const result = await validateToken(useToken);
      if (result.result) {
        fetchOrders(result.token);
        setToken(result.token);
      } else if (result.code === 1 && result.token) {
        setAgreementToken(result.token);
        setAgreementRequired(true);
      } else {
        showAlert('토큰이 유효하지 않습니다.');
        navigate('/anyfit/error');
      }
    };

    const parseUrl = async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const impUid = urlParams.get('imp_uid');
      const merchantUid = urlParams.get('merchant_uid');
      const impSuccess = urlParams.get('imp_success');
      const errorMsg = urlParams.get('error_msg');
      // const selectedPrice = localStorage.getItem('selectedPrice');
      // const savedURL = localStorage.getItem('savedURL');

      if (errorMsg != null) {
        // 결제 실패 케이스
        showAlert(errorMsg);
      } else if (impSuccess == 'true') {
        console.log('queryString...' + queryString);
        // alert('queryString' + queryString);
        // 결제 성공 케이스
        // complete_input = {
        //   imp_uid: paramValue,
        //   merchant_uid: paramValue2,
        // };
        // completeOrder();
        // const modifiedMerchantUid =
        //   process.env.REACT_APP_ENV + 'ss' + merchantUid.toString();
        await completeOrder(impUid, merchantUid.split('ss')[1]);
      }
    };

    // 배송 공지 팝업 표시 여부 확인
    const checkShippingNotice = () => {
      const isDismissed = localStorage.getItem('shippingNoticePopup_dismissed');
      if (!isDismissed) {
        setShowShippingNotice(true);
      }
    };

    initialize();
    parseUrl();
    checkShippingNotice();
  }, []);

  const navigate = useNavigate();
  const [orderList, setOrderList] = useState([
    {
      status: '주문완료',
      date: '2024-05-01',
      img_url:
        'https://glucofit-image.s3.ap-northeast-2.amazonaws.com/LOG/prodImage.png',
      product_name: 'CGM패키지 (무료)',
      product_price: 81000,
    },
  ]);
  const [token, setToken] = useState('');

  const formatDateTime = (isoString) => {
    if (!isoString) {
      return '';
    }
    // ISO 8601 형식의 문자열을 Date 객체로 파싱
    const date = new Date(isoString);

    // 원하는 형식 지정
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    // 'ko-KR' 로케일에 따라 원하는 형식으로 변환
    const formatter = new Intl.DateTimeFormat('ko-KR', options);
    const formattedDateTime = formatter
      .format(date)
      .replace(/-/g, '.')
      .replace(/,/g, '');

    // 날짜만 반환
    return formattedDateTime.slice(0, 13);
  };

  const formatExpectedDate = (dateString) => {
    if (!dateString) {
      return '-';
    }
    if (/^\d{8}$/.test(dateString)) {
      return `${dateString.slice(0, 4)}. ${dateString.slice(
        4,
        6,
      )}. ${dateString.slice(6, 8)}`;
    }
    return dateString;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 선물 탭 활성화 시 1회 fetch
  useEffect(() => {
    if (activeTab !== 'gift' || giftLoaded) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    giftApi
      .history(token)
      .then(({ data }) => {
        setGiftOrders(data.orders || []);
        setGiftLoaded(true);
      })
      .catch(() => {
        setGiftOrders([]);
        setGiftLoaded(true);
      });
  }, [activeTab, giftLoaded]);

  // 배송 공지 팝업 닫기 핸들러
  const handleShippingNoticeClose = () => {
    setShowShippingNotice(false);
  };

  const handleAgreementConfirm = () => {
    const returnUrl = encodeURIComponent(
      window.location.pathname + window.location.search,
    );
    navigate(
      `/anyfit/agreement?TOKEN=${agreementToken}&returnUrl=${returnUrl}`,
      { replace: true },
    );
  };

  return (
    <Layout>
      {/* 배송 공지 팝업 */}
      {showShippingNotice && (
        <ShippingNoticePopup onClose={handleShippingNoticeClose} />
      )}

      <Container>
        <Top>
          <Title>구매내역</Title>
        </Top>
        <TabRow>
          <TabBtn
            $active={activeTab === 'purchase'}
            onClick={() => startTransition(() => setActiveTab('purchase'))}
          >
            구매한 내역
            {orderList.length > 0 ? <Count>{orderList.length}</Count> : null}
          </TabBtn>
          <TabBtn
            $active={activeTab === 'gift'}
            onClick={() => startTransition(() => setActiveTab('gift'))}
          >
            선물한 내역
            {giftOrders.length > 0 ? <Count>{giftOrders.length}</Count> : null}
          </TabBtn>
        </TabRow>
        {activeTab === 'purchase' &&
          (!orderList || orderList.length === 0 ? (
            <NotContent>
              아직 구매 내역이 <br />
              없습니다.
            </NotContent>
          ) : (
            <OrderListContainer>
              {orderList.map((order, index) => (
                <OrderCard key={index}>
                  <OrderCardUpper>
                    <OrderStatus>
                      <StatusBadge status={order.state}>
                        {order.state == 'COMPLETE'
                          ? '주문완료'
                          : order.state == 'USE'
                          ? '배송완료'
                          : order.state == 'CANCEL'
                          ? '주문취소'
                          : '배송중'}
                        {/* //USE 케이스 추가  */}
                      </StatusBadge>
                    </OrderStatus>
                    <OrderDate>
                      · 구매일 {formatDateTime(order?.created_at)}
                      {/* COMPLETE 일 경우 취소하기 버튼 */}
                    </OrderDate>
                    <OrderDate>
                      · 배송시작예정일{' '}
                      {formatExpectedDate(
                        order?.delivery?.expected_delivery_date,
                      )}
                    </OrderDate>
                  </OrderCardUpper>
                  <OrderCardLower>
                    <OrderImage
                      src={order?.product?.img_url}
                      alt={order?.product?.name}
                    />
                    <OrderDetails>
                      <OrderName>주문 ID : {order?.id}</OrderName>
                      <OrderName>{order?.product?.name}</OrderName>
                      <OrderPrice>
                        {order?.product?.price?.toLocaleString()}원
                      </OrderPrice>
                      {order?.deliver_address && (
                        <ShippingAddress>
                          배송지 : {order.deliver_address}{' '}
                          {order?.detail_address && (
                            <span>({order.detail_address})</span>
                          )}
                        </ShippingAddress>
                      )}
                      <ButtonContainer>
                        <ShippingInquiryButton
                          onClick={() =>
                            window.open(
                              'https://glucofit.channel.io/home',
                              '_blank',
                            )
                          }
                        >
                          배송 문의
                        </ShippingInquiryButton>
                        {order.state == 'COMPLETE' && (
                          <OrderCancelButton
                            orderId={order.id}
                            fetchOrders={fetchOrders}
                            token={token}
                          >
                            주문취소
                          </OrderCancelButton>
                        )}
                      </ButtonContainer>
                    </OrderDetails>
                  </OrderCardLower>
                </OrderCard>
              ))}
            </OrderListContainer>
          ))}
        {activeTab === 'gift' && (
          <OrderListContainer>
            {giftOrders.length === 0 ? (
              <NotContent>선물한 내역이 없습니다</NotContent>
            ) : (
              giftOrders.map((order) => (
                <OrderCard key={order.id}>
                  <OrderCardUpper>
                    <StatusBadge status="DEFAULT">선물 완료</StatusBadge>
                    <OrderDate>
                      · {new Date(order.created_at).toLocaleString('ko-KR')}
                    </OrderDate>
                    <OrderDate>
                      · 배송시작예정일{' '}
                      {formatExpectedDate(
                        order?.delivery?.expected_delivery_date,
                      )}
                    </OrderDate>
                  </OrderCardUpper>
                  <OrderCardLower>
                    <OrderImage
                      src={order.product?.img_url}
                      alt={order.product?.name}
                    />
                    <OrderDetails>
                      <OrderName>주문 ID · GF-{order.id}</OrderName>
                      <OrderName>{order.product?.name}</OrderName>
                      <OrderPrice>
                        {order.payment?.amount?.toLocaleString()}원
                      </OrderPrice>
                      <OrderName>
                        받는 분 · {order.receiver_name} ({order.phone_number})
                      </OrderName>
                      {order?.deliver_address && (
                        <ShippingAddress>
                          배송지 : {order.deliver_address}{' '}
                          {order?.detail_address && (
                            <span>({order.detail_address})</span>
                          )}
                        </ShippingAddress>
                      )}
                      <ButtonContainer>
                        <ShippingInquiryButton
                          onClick={() =>
                            window.open(
                              'https://glucofit.channel.io/home',
                              '_blank',
                            )
                          }
                        >
                          배송 문의
                        </ShippingInquiryButton>
                      </ButtonContainer>
                    </OrderDetails>
                  </OrderCardLower>
                </OrderCard>
              ))
            )}
          </OrderListContainer>
        )}
        {activeTab === 'purchase' && (
          <Guide>
            <div>
              <p>□ 보험연계 부가서비스로 신청하신 경우</p>
              <ol style={{ marginLeft: '2px' }}>
                <li>환불이 불가합니다.</li>
                <li>
                  보험 상품의 기초서류에 기재된 부가서비스 요건에 따라 신청을
                  완료하였더라도, 보험가입일로부터 +30일 이후에 배송됩니다.
                  <br />
                  (예시) 보험가입일이 2025.01.01인 경우, 2025.01.31 이후
                  영업일에 배송이 시작됩니다.
                </li>
              </ol>
              <p>□ 직접 슈가핏 서비스를 구매하신 경우</p>
              <ol style={{ marginLeft: '2px' }}>
                <li>택배 출고 전 환불 신청 시 전액 환불됩니다.</li>
                <li>
                  배송이 완료된 상품은 상품 수령일로부터 7일 이내, 개봉 전
                  상품에 한해 전액 환불이 가능합니다.
                  <br />( 단, 반품 시에 발생하는 왕복 배송비(9,000원)는 고객
                  부담 -전자상거래 등에서의 소비자보호에 관한 법률 제17조- )
                </li>
                <li>
                  아래에 해당한 경우 교환 및 환불이 불가합니다.
                  <ul style={{ marginLeft: '2px' }}>
                    <li>
                      - 센서를 부착한 이후(센서 하자일 경우 새 상품으로 1:1
                      교체해드립니다.)
                    </li>
                    <li>
                      - 슈가핏 패키지 수령 후 개봉 및 내/외부 포장 파손 시
                    </li>
                    <li>
                      - 소비자의 고의, 과실로 인한 슈가핏 패키지가 파손 및
                      훼손된 경우
                    </li>
                    <li>
                      - 센서의 구조, 기능을 개조 또는 상품을 변조하여 문제가
                      발생된 경우
                    </li>
                    <li>- 천재지변에 의해 발생한 피해</li>
                  </ul>
                </li>
                <li>
                  교환 및 반품 환불은 상품 도착 및 상품상태 점검 후
                  이루어집니다.
                  <ul style={{ marginLeft: '2px' }}>
                    <li>
                      - 반품 상품 점검 시 교환/반품 불가 사유에 해당될 경우
                      반품/환불은 불가
                    </li>
                    <li>
                      - 구성품의 패키지 구성품의 일부가 누락되거나 반품 입고가
                      되지 않았을 경우 환불 지연
                    </li>
                    <li>
                      - 지정된 택배사 외 타 업체 이용 시 반품/교환이 지연되거나
                      추가 비용이 발생
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
          </Guide>
        )}
        {activeTab === 'gift' && (
          <Guide>
            <div>
              <p>□ 선물하기 서비스를 이용하신 경우</p>
              <ol style={{ marginLeft: '2px' }}>
                <li>
                  택배 출고 전 환불 신청 시 전액 환불
                  <ul style={{ marginLeft: '2px' }}>
                    <li>
                      - 모든 환불 금액은 실제 결제를 진행한 결제자에게
                      환원됩니다.
                    </li>
                  </ul>
                </li>
                <li>
                  배송 완료 상품의 환불
                  <ul style={{ marginLeft: '2px' }}>
                    <li>
                      - 수령일로부터 7일 이내, 개봉 전 상품, 쿠폰 미사용 상품에
                      한해 환불 가능 (왕복 배송비 9,000원 신청자 부담)
                    </li>
                    <li>
                      - 환불 신청 시 수령자의 상품 수거가 완료된 후 최종 환불
                      처리가 가능합니다.
                    </li>
                    <li>
                      - 수령자에게 3회 요청 후에도 응답이 없거나 수거가 원활하지
                      않을 경우 환불이 불가하며 요청은 자동 종결됩니다.
                    </li>
                  </ul>
                </li>
                <li>
                  교환·환불 불가 사유
                  <ul style={{ marginLeft: '2px' }}>
                    <li>
                      - 센서를 부착한 이후 (단, 센서 하자일 경우 새 상품 1:1
                      교체)
                    </li>
                    <li>
                      - 슈가핏 패키지 수령 후 개봉 및 내/외부 포장 파손 시
                    </li>
                    <li>- 소비자의 고의·과실로 패키지가 파손·훼손된 경우</li>
                    <li>
                      - 센서의 구조·기능 개조 또는 상품 변조로 문제 발생 시
                    </li>
                    <li>- 천재지변에 의한 피해</li>
                  </ul>
                </li>
              </ol>
            </div>
          </Guide>
        )}
      </Container>
      <AnyfitBackButton
        onClick={() => {
          window.location.href = branding.deepLink;
        }}
      >
        {branding.name}로 바로가기
      </AnyfitBackButton>
      {agreementRequired && (
        <AgreementRequiredModal onConfirm={handleAgreementConfirm} />
      )}
    </Layout>
  );
};

export default AnyfitOrderList;
